import ExpoAiLogo from 'pared/images/Expo/expoai.png'

import { IConfigsType } from '../../types'

const bibibopHome: IConfigsType = {
  bibibop: {
    '/:brand/scorecard': {
      groupFilter: {
        api: 'locationFilter',
      },
      title: {
        type: 'title',
        title: 'locationInfo',
        subTitle: 'storeSubtitle',
        titleMargin: '0px',
      },
      note: {
        type: 'typography',
        apiOrContent: 'Trailing 30 Days of Data',
        variant: 'body2',
        margin: '8px 0px 50px',
      },
      image: {
        type: 'image',
        src: ExpoAiLogo,
        alt: 'Expo AI',
        height: '40px',
      },
      exray: {
        type: 'ai-summary',
        total: 'Total Opportunities: <%- total %> Monthly',
        fields: [
          'bbbMonthlySales',
          'bbbMonthlyLabor',
          'bbbFoodCost',
          'delivery',
        ],
      },
      chatbox: {
        type: 'chatbox',
        hasSalesAnalysisButton: true,
      },
    },
  },
}

export default bibibopHome
